import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="livestream"
// Polls the livestream status while it is in flux (Starting/Stopping). It sends the status it is
// showing: while that's unchanged the server only refreshes the "Updated …" timestamp; once it
// changes, the livestream partial is re-rendered (replacing this element), so polling stops by
// itself when the status settles.
export default class extends Controller {
  static values = {poll: Boolean, workoutId: Number, status: String}

  connect() {
    if (this.pollValue) {
      this.startPolling()
    }
  }

  disconnect() {
    this.stopPolling()
  }

  startPolling() {
    this.stopPolling()
    // Kept on the instance: LivePreviewVideo uses window.poll_interval for its own timer.
    this.pollTimer = setInterval(this.fetchLivestreamStatus.bind(this), 5000)
  }

  stopPolling() {
    clearInterval(this.pollTimer)
    this.pollTimer = null
  }

  async fetchLivestreamStatus() {
    if (this.fetching) return

    this.fetching = true
    try {
      const params = new URLSearchParams({id: this.workoutIdValue, status: this.statusValue})
      const response = await fetch(`/admin/workouts/livestream_status?${params}`, {
        headers: {Accept: "text/vnd.turbo-stream.html"}
      })
      if (response.ok) {
        Turbo.renderStreamMessage(await response.text())
      }
    } catch (error) {
      console.warn("livestream status poll failed", error)
    } finally {
      this.fetching = false
    }
  }
}
